import { connect } from 'react-redux';
import { fetchDashboardData } from '../../store/app/apis';
import { useEffect, useState, useRef } from 'react';
import TablePagination from '@mui/material/TablePagination';
import { getTime } from '../../utils';
import SearchIcon from '@mui/icons-material/Search';
import styles from './dashboard.module.css';
import Toast from 'light-toast';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
export function Dashboard({ baseurl, fetchDashboardData, dashboardList, dashboardCount }) {
  const options = {
    MEDIA: 'media.list',
    JOB: 'job.list',
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [type, setType] = useState(options.MEDIA);
  const [mediastatus, setMediastatus] = useState('All');
  const [jobstatus, setJobstatus] = useState('All');
  const searchRef = useRef();
  const [key, setKey] = useState('');
  const MEDIA_STATUS = {
    All: [1, 2, 3, 4, 5],
    Request: [1],
    Uploading: [2],
    Uploaded: [3],
    Processing: [4],
    Complete: [5],
  };
  const JOB_STATUS = {
    All: [0, 1, 2, 3],
    Empty: [0],
    Created: [1],
    Running: [2],
    Completed: [3],
  };
  const UPLOAD_STATUS = {
    0: 'All',
    1: 'Request',
    2: 'Uploading',
    3: 'Uploaded',
    4: 'Processing',
    5: 'Complete',
  };
  const muistyling = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#1976d2',
      height: '35px',
      overflow: 'hidden',
      svg: {
        color: '#ffffff',
      },
    },
    '& .MuiOutlinedInput-input': {
      color: 'rgba(255,255,255,1)',
      fontSize: '12px',
    },
    '& .MuiAutocomplete-input': {
      width: '30px',
      padding: '0px 4px 7.5px 5px',
    },
  };

  const CustomTooltip = ({ title, linkUrl, linkText, children }) => {
    const typographyStyle = {
      backgroundColor: 'white', // Set white background color for the Typography element
      padding: '8px', // Add padding if needed
    };
    return (
      <Tooltip
        title={
          <>
            <Typography variant="subtitle1">{title}</Typography>
            {linkUrl && (
              <Typography variant="body2" style={typographyStyle}>
                <a href={linkUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  {linkText}
                </a>
                <ContentCopyIcon
                  onClick={() => copyToIpClipboard(linkText)}
                  sx={{ fontSize: 'small', cursor: 'pointer', color: 'black' }}
                />
              </Typography>
            )}
          </>
        }
        arrow
      >
        {children}
      </Tooltip>
    );
  };
  const keyByValue = (appObj, value) => {
    const [key] = Object.entries(appObj).find(([key, val]) => val === value) || [];
    return key || null;
  };
  const onChange = (searchTerm) => {
    setKey('');
    setPage(0);
  };
  const onSearch = (event) => {
    if (searchRef.current.value === '') {
      setKey('');
      return;
    }
    const value = searchRef.current.value;
    setKey(value);
    setPage(0);
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleStatusChange = (event) => {
    if (type === options.MEDIA) {
      setMediastatus(event.target.value);
    } else {
      setJobstatus(event.target.value);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const flavorsplitter = (flavor) => {
    let flv = flavor.split('_');
    return flv[0];
  };
  const copyToIpClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
      })
      .catch((error) => {
        Toast.fail('Text not copied!');
      });
  };
  useEffect(() => {
    var payload = {};
    payload['page'] = page + 1;
    payload['size'] = rowsPerPage;
    if (type === options.MEDIA) {
      payload['status'] = MEDIA_STATUS[mediastatus];
    } else {
      payload['status'] = JOB_STATUS[jobstatus];
    }

    if (key !== '') {
      payload['id'] = key;
    }
    fetchDashboardData(payload, baseurl, type);
  }, [page, rowsPerPage, key, type, mediastatus, jobstatus]);

  return (
    <div className={styles.logs}>
      <div className={styles.topbar}>
        <div className={styles.log_bar}>
          <input
            type="text"
            ref={searchRef}
            onChange={onChange}
            placeholder={`Search in ${keyByValue(options, type)}`}
          />
          <button onClick={onSearch}>
            <SearchIcon />
          </button>
        </div>
        <div>
          <Box sx={muistyling}>
            <FormControl>
              <Select value={type} onChange={handleTypeChange}>
                {Object.entries(options)?.map(([key, value], index) => (
                  <MenuItem key={index} value={value}>
                    {key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </div>
        <div>
          <Box sx={muistyling}>
            <FormControl>
              <Select value={type === options.MEDIA ? mediastatus : jobstatus} onChange={handleStatusChange}>
                {Object.entries(type === options.MEDIA ? MEDIA_STATUS : JOB_STATUS)?.map(([key, value], index) => (
                  <MenuItem key={index} value={key}>
                    {key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
      <div className={styles.logsbackground}>
        <table>
          <thead>
            <tr>
              <th>{keyByValue(options, type) + ' ' + 'ID'}</th>
              <th>{keyByValue(options, type) + ' ' + 'TASK STATUS'}</th>
              <th>STATUS</th>
              <th>FLAVORS</th>
              <th>CT</th>
              <th>READY</th>
            </tr>
          </thead>
          <tbody>
            {dashboardList?.map((list) => (
              <tr key={list?.id}>
                <td>
                  <span className="tableip">
                    <CustomTooltip
                      title="M3U8 Url:"
                      linkUrl={list?.baseurl + list?.hls}
                      linkText={list?.baseurl + list?.hls}
                    >
                      <p className="widthfix">{list?.id}</p>
                    </CustomTooltip>
                    <Tooltip>
                      <ContentCopyIcon
                        onClick={() => copyToIpClipboard(list?.id)}
                        sx={{ fontSize: 'small', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  </span>
                </td>
                <td>
                  <span>
                    Thumb:{list?.jobstatus?.['thumb']?.['status']}
                    <br></br>
                  </span>
                  <span>
                    Imagereel:{list?.jobstatus?.['imagereel']?.['status']}
                    <br></br>
                  </span>
                  <span>Transcode:{list?.jobstatus?.['transcode']?.['status']}</span>
                </td>
                <td>{UPLOAD_STATUS[list?.status]}</td>
                <td>
                  {list?.['job']?.['transcode']?.['flavors']?.map((flavor) => (
                    <span>
                      {flavorsplitter(flavor.name)}
                      <br></br>
                    </span>
                  ))}{' '}
                </td>
                <td>{getTime(list?.ct)}</td>
                <td>{list?.ready === true ? 'YES' : 'NO'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 15, 25, 50, 100, 200, 300, 400, 500]}
        component="div"
        onRowsPerPageChange={handleChangeRowsPerPage}
        count={dashboardCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  dashboardList: state.app.dashboardList,
  dashboardCount: state.app.dashboardCount,
});
const mapDispatchToProps = {
  fetchDashboardData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
